/**
 * Polygon types for boolean operations
 */
export enum PolygonType {
  SUBJECT = 0,
  CLIPPING = 1,
}